import React from "react"
import type { CadastroPromocaoFidelidadeModel } from "../models/cadastroPromocaoFidelidadeModel"
import { CadastroPromocaoFidelidadeInicial } from "../models/cadastroPromocaoFidelidadeModel"
import type { CadastroPromocaoFidelidadeActionModel } from "./cadastroPromocaoFidelidadeActions"

type CadastroPromocaoFidelidadeContextType = {
    dados: CadastroPromocaoFidelidadeModel
    dispatch: React.Dispatch<CadastroPromocaoFidelidadeActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const CadastroPromocaoFidelidadeContext =
    React.createContext<CadastroPromocaoFidelidadeContextType>({
        dados: CadastroPromocaoFidelidadeInicial,
        dispatch: () => undefined,
        salvar: async () => undefined,
        erroCarregamento: null,
    })
